<div *ngIf="isAuthorised">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div>
    <div class="ia-action-div" *ngIf="currentUserRole === 'Compliance Enterprise' || isSavedPermission">
      <!-- For Save, version, notification button -->
      <span class="cursor-pointer text-primary ml-2 pull-right" *ngIf="filterType !== 'version'"
        (click)="updateImpactAssessmentDetails()"><i class="fa fa-floppy-o text-dark"></i>
        Save</span>
      <!-- <span class="cursor-pointer text-primary pull-right ml-2" (click)="downloadReport()"><i
                    class="fa fa-download text-dark"></i> Export Report</span> -->
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADRT')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = true"
          *ngIf="!impactAssessment.isRecordTime" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = false"
          *ngIf="impactAssessment.isRecordTime" aria-hidden="true"></i>
        Record Time
      </span>
      <span class="cursor-pointer text-primary ml-2 pull-right"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && !impactAssessment.isMerged"
        (click)="openRegulationDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
      <span class="cursor-pointer text-primary ml-2 pull-right"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && impactAssessment.isMerged"
        (click)="openBulkCloseDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADSN')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isSendNotification = true"
          *ngIf="!impactAssessment.isSendNotification" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle"
          (click)="impactAssessment.isSendNotification = false" *ngIf="impactAssessment.isSendNotification"
          aria-hidden="true"></i>
        Send Notification
      </span>
      <a (click)="backToCurrentVersion()" *ngIf="filterType === 'version'"
        class="cursor-pointer text-primary pull-right ml-2"><i class="fa fa-undo text-dark"></i>
        Current Version</a>
      <span class="cursor-pointer text-primary pull-right ml-2" (click)="openDialog()"><i
          class="fa fa-history text-dark"></i> Version History</span>
      <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Next')">
        <span class="text-primary float-left" (click)="getSiblings('Next')">Next</span>
      </span>
      <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Previous')">
        <span class="text-primary float-left ml-4" (click)="getSiblings('Previous')">Previous</span>
      </span>
    </div>
    <div class="pl-2 IA5-template ia-details-div">
      <mat-accordion id="SummaryDetails">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                SUMMARY DETAILS
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row mr-0 ml-0" *ngIf="impactAssessment.isMerged">
            <span class="ml-4 mr-3"><label class="control-label fw inline-block">Assessment Id
              </label></span>
            <a>
              <span *ngFor="let item of impactAssessment.merged_Id|stringToArray;" (click)="getUpdatedDbInfo(item)">
                <span
                  [ngClass]="this.impactAssessment.updatedDB_Id == item ?  'parent-id':'link-id d-inline-block'">{{item}}<span
                    class="cursor-pointer ml-1"
                    *ngIf="this.impactAssessment.updatedDB_Id != item && (currentUserRole === 'Compliance Enterprise' || isSavedPermission)"
                    (click)="updateOtherMergedId(item)"><i class="fa fa-times-circle text-white"></i></span></span>
              </span>
            </a>
            <span class="parent-span">
              <label class="control-label fw mr-2 inline-block"> Parent Id </label>
              <span *ngIf="!isParentIdEdit" class="control-label inline-block">{{impactAssessment.updatedDB_Id}}</span>
              <span *ngIf="!isParentIdEdit" class="cursor-pointer text-primary ml-2" (click)="updateParentId()">
                Edit</span>
              <span *ngIf="isParentIdEdit" class="inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="parentId">
                  <option *ngFor="let item of impactAssessment.merged_Id|stringToArray;" value="{{item}}">{{item}}
                  </option>
                </select>
              </span>
              <span *ngIf="isParentIdEdit" class="cursor-pointer text-primary ml-2" (click)="changeParentId()">Confirm
              </span>
            </span>
          </div>
          <div class="row form-group ml-2 mt-1">
            <div class="col-lg-2 col-md-2 mx-width-10pr">
              <label class="control-label fw"> {{ impactAssessment.isMerged? "Id":"Assessment Id"
                }}</label>
              <div class="control-label" name="ids">{{ this.currentinfoId }}</div>
            </div>
            <div class="col-lg-4 col-md-4 mx-width-40pr">
              <label class="control-label fw">Title</label>
              <div class="control-label div-scroll" name="title">{{ impactAssessment.title }}</div>
            </div>
            <div class="col-lg-1 mx-width-11pr">
              <label class="control-label fw">Type</label>
              <div class="control-label" name="type">{{ impactAssessment.pubType }}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Geography</label>
              <div class="control-label">{{impactAssessment.geography}}</div>
            </div>
            <div class="col-lg-2 mx-width-8pr">
              <label class="control-label fw">Country</label>
              <div class="control-label">{{impactAssessment.country}}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Regulator</label>
              <div class="control-label">{{impactAssessment.regulator}}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Date</label>
              <div class="control-label">{{impactAssessment.updatedDB_Date | date: 'dd-MMM-yyyy' }}</div>
            </div>
            <div class="col-lg-1 mx-width-7pr"
              *ngIf="impactAssessment.isRecordTime && commonService.checkPlanTypeAction('IADRT')">
              <label class="control-label fw">Time Spent </label>
              <div class="control-label">{{impactAssessment.timeSpent | minToHour}}</div>
            </div>
          </div>

          <div class="row ml-2">
            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-9 fw">
                  <label class="control-label fw">Description</label>
                </div>
                <div class="col-lg-3" *ngIf="impactAssessment.hyperlink">
                  <a href="{{impactAssessment.hyperlink}}" class=" pull-right" target="_blank">
                    <i class="fa fa-globe"></i>
                    <span class="text-primary cursor-pointer">
                      Source Link</span>
                  </a>
                </div>
                <div class="col-lg-3" *ngIf="!impactAssessment.hyperlink">
                  <span class="pull-right"><i class="fa fa-globe"></i><span> Source Link</span></span>
                </div>
                <div class="col-lg-12 edit_status_changeViewer_group">
                  <div class="edit_status_changeViewer_group">
                    <div *ngIf="impactAssessment.description | hasHtmlTags; else noHtmlTags"
                      [innerHTML]="impactAssessment.description"></div>
                    <ng-template #noHtmlTags>
                      <mat-form-field class="disableText w-100">
                        <textarea matInput cdkTextareaAutosize disabled
                          class="text-area-css textarea_input">{{impactAssessment.description}}</textarea>
                      </mat-form-field>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 desc-text-box" *ngIf="currentinfoId > 0">
              <app-current-action [userId]="userAccessToken.userId" [itemId]="currentinfoId" [closedType]="'Assess'">
              </app-current-action>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="AssessmentDetails">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                ASSESSMENT DETAILS
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 my-4">
            <div class="col-lg-6">
              <label class="control-label fw">Response Lead</label>
              <mat-chip-grid #responseLeadList>
                <mat-chip-row *ngFor="let responseLead of responseLeadDD" [selectable]="selectable"
                  [removable]="removable" (removed)="removeResponseLead(responseLead)">
                  {{responseLead}}
                  <mat-icon matChipRemove
                    [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)" *ngIf="removable"
                    class="clear-icons">clear</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  [readonly]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  #trigautoResponseLead="matAutocompleteTrigger" (keydown)="getFilteredData('ResponseLead', $event)"
                  #responseLeadInput [formControl]="searchResponseLeadCntrl"
                  [matAutocomplete]="responseLeadAutocomplete" [matChipInputFor]="responseLeadList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off" (matChipInputTokenEnd)="addResponseLead($event)">
              </mat-chip-grid>
              <mat-autocomplete #responseLeadAutocomplete="matAutocomplete"
                (optionSelected)="selectedResponseLeadEvent($event)">
                <mat-option *ngFor="let responseLead of searchedResponseLead" [value]="responseLead.value">
                  {{responseLead.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-6">
              <label class="control-label fw">Accountable Executive</label>
              <mat-chip-grid #accountableExecutiveList>
                <mat-chip-row *ngFor="let accountableExecutive of accountableExecutiveDD" [selectable]="selectable"
                  [removable]="removable" (removed)="removeAccountableExecutive(accountableExecutive)">
                  {{accountableExecutive}}
                  <mat-icon matChipRemove
                    [disable]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)" *ngIf="removable"
                    class="clear-icons">clear</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  [readonly]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  #trigautoAccountableExecutive="matAutocompleteTrigger"
                  (keydown)="getFilteredData('AccountableExecutive', $event)" #accountableExecutiveInput
                  [formControl]="searchAccountableExecutiveCntrl" [matAutocomplete]="accountableExecutiveAutocomplete"
                  [matChipInputFor]="accountableExecutiveList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addAccountableExecutive($event)">
              </mat-chip-grid>
              <mat-autocomplete #accountableExecutiveAutocomplete="matAutocomplete"
                (optionSelected)="selectedAccountableExecutiveEvent($event)">
                <mat-option *ngFor="let accountableExecutive of searchedAccountableExecutive"
                  [value]="accountableExecutive.value">
                  {{accountableExecutive.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row ml-2">
            <div class="col-lg-3">
              <label class="control-label fw">Team</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.team"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)">
                <option *ngFor="let option of team" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Rule Type</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ruleType"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)">
                <option *ngFor="let option of ruleType" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Last Updated</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="lastUpdatedTime" disabled (click)="lastUpdatedTime.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.lastUpdatedTime"
                  name="LastUpdatedTime" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="lastUpdatedTime.open()"></span>
                </div>
              </div>
              <mat-datepicker #lastUpdatedTime></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label rag_ratingLabel fw">RAG Rating
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.ragRating">None</span>
                <span class="label label-default p5-20" [style.background-color]="getBackgroundColor('Red')"
                  *ngIf="impactAssessment.ragRating === 'Red'">Red</span>
                <span class="label ml-2 label-default p5-20" [style.background-color]="getBackgroundColor('Amber')"
                  *ngIf="impactAssessment.ragRating === 'Amber'">Amber</span>
                <span class="label ml-2 label-default p5-20" [style.background-color]="getBackgroundColor('Green')"
                  *ngIf="impactAssessment.ragRating === 'Green'">Green</span>
                <span class="label ml-2 label-default p5-20" [style.background-color]="getBackgroundColor('No Impact')"
                  *ngIf="impactAssessment.ragRating === 'No Impact'">No Impact</span>
              </label>
              <div class="dropdown-color-selector">
                <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ragRating"
                  [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)">
                  <option *ngFor="let option of ragRating" value="{{ option.itemTitle }}">
                    {{ option.itemTitle }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-6">
              <label class="control-label fw">Topic <span class="stars">*</span></label>
              <mat-chip-grid #topicList>
                <mat-chip-row *ngFor="let topic of ruleTopicDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeTopic(topic)">
                  {{topic}}
                  <mat-icon matChipRemove
                    [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)" *ngIf="removable"
                    class="clear-icons">clear</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  [readonly]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  #trigautoTopicExecutive="matAutocompleteTrigger" (keydown)="getFilteredData('RuleTopic', $event)"
                  #topicInput [formControl]="searchTopicCntrl" [matAutocomplete]="topicAutocomplete"
                  [matChipInputFor]="topicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addTopic($event)">
              </mat-chip-grid>
              <mat-autocomplete #topicAutocomplete="matAutocomplete" (optionSelected)="selectedTopicEvent($event)">
                <mat-option *ngFor="let topic of searchedTopic" [value]="topic.value">
                  {{topic.name}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-3">
              <label class="control-label fw">Response Deadline </label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="resposeDeadline" (click)="resposeDeadline.open()"
                  [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  class="form-control form-control-sm border-bottom" (dateInput)="updateSectionLastEdited()"
                  [(ngModel)]="impactAssessment.resposeDeadline" name="ResposeDeadline" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="resposeDeadline.open()"></span>
                </div>
              </div>
              <mat-datepicker #resposeDeadline (selectedChanged)="updateSectionLastEdited()"></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Consultation Period</label>
              <input type="text" class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.consultationPeriod" disabled>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Effective Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="effectiveDate" (click)="effectiveDate.open()"
                  [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.effectiveDate"
                  name="EffectiveDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="effectiveDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #effectiveDate></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Did We Respond?</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.didWeRespond"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Response Approach</label>
              <select class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.responseAppraoch">
                <option *ngFor="let option of responseApproach" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Response Submission Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="responseSubmissionDate"
                  [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  (click)="responseSubmissionDate.open()" class="form-control form-control-sm border-bottom"
                  [(ngModel)]="impactAssessment.responseSubmissionDate" name="ResponseSubmissionDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="responseSubmissionDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #responseSubmissionDate></mat-datepicker>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Extension Requested?</label>
              <select class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.extensionRequested">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Current Status <span class="stars">*</span></label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.currentStatus"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)">
                <option *ngFor="let option of currentStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Next Action Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="nextActionDate" (click)="nextActionDate.open()"
                  [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.nextActionDate"
                  name="NextActionDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="nextActionDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #nextActionDate></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Next Action Step</label>
              <input type="text" class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.nextActionStep">
            </div>
          </div>
          <div class="row gap-2 ml-2 my-4">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span class="control-label d-block fw mb-2">
                  Policy Reform Summary
                </span>
              </div>
              <app-ck-editor [(childVariable)]="impactAssessment.policyReformSummery" [accessType]="accessType"
                *ngIf="isSADetails1" id="policyReformSummery" class="f-16 ck-min-height"
                [data]="impactAssessment.policyReformSummery"></app-ck-editor>
            </div>
            <div class="row ml-0 pt-3">
              <span class="text-primary ml-0 fw" *ngIf="!isSavedPermission">Upload - Policy Reform Summary</span>
              <div class="col-12 cursor-pointer" *ngIf="isSavedPermission"
                (click)="uploadEvidenceAssessment('uploadPolicyReform')">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload - Policy Reform Summary
                  <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadPolicyReform" #myFileInput1
                  (change)="handleFileInput($event.target.files, FileType.Policy)" type="file" multiple
                  style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === FileType.Policy">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isSavedPermission"
                      (click)="openDeleteModel(docs.id)"></span>
                    <span class="cursor-pointer" (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension)">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="header-text">
                <span class="control-label d-block mb-2 fw">
                  Response Key Messages
                </span>
              </div>
              <app-ck-editor [(childVariable)]="impactAssessment.responseKeyMessages" [accessType]="accessType"
                *ngIf="isSADetails2" id="responseKeyMessages" class="f-16 ck-min-height"
                [data]="impactAssessment.responseKeyMessages"></app-ck-editor>
            </div>
            <div class="row ml-0 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isSavedPermission">Upload - Response Key Messages</span>
              <div class="col-12 cursor-pointer" *ngIf="isSavedPermission"
                (click)="uploadEvidenceAssessment('uploadResKeyMsg')">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload - Response Key Messages
                  <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadResKeyMsg" #myFileInput1
                  (change)="handleFileInput($event.target.files, FileType.Response)" type="file" multiple
                  style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === FileType.Response">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isSavedPermission"
                      (click)="openDeleteModel(docs.id)"></span>
                    <span class="cursor-pointer" (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension)">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="header-text">
                <span class="control-label mb-2 d-block fw">
                  External Stakeholder Positions
                </span>
              </div>
              <app-ck-editor [(childVariable)]="impactAssessment.externalStakeHolderPositions" [accessType]="accessType"
                *ngIf="isSADetails3" id="externalStakeHolderPositions" class="f-16 ck-min-height"
                [data]="impactAssessment.externalStakeHolderPositions"></app-ck-editor>
            </div>
            <div class="row ml-0 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isSavedPermission">Upload - External Stakeholder
                Positions</span>
              <div class="col-12 cursor-pointer" *ngIf="isSavedPermission"
                (click)="uploadEvidenceAssessment('uploadExternalStackHolderPacks')">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload - External Stakeholder Positions
                  <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadExternalStackHolderPacks" #myFileInput1
                  (change)="handleFileInput($event.target.files, FileType.ExternalStackholder)" type="file" multiple
                  style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === FileType.ExternalStackholder">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isSavedPermission"
                      (click)="openDeleteModel(docs.id)"></span>
                    <span class="cursor-pointer" (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension)">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="header-text">
                <span class="control-label mb-2 d-block fw">
                  Internal Stakeholders and Packs
                </span>
              </div>
              <app-ck-editor [(childVariable)]="impactAssessment.internalStakeholdersPacks" [accessType]="accessType"
                *ngIf="isSADetails4" id="internalStakeholdersPacks" class="f-16 ck-min-height"
                [data]="impactAssessment.internalStakeholdersPacks"></app-ck-editor>
            </div>
            <div class="row ml-0 pt-3">
              <span class="text-primary ml-1 fw" *ngIf="!isSavedPermission">Upload - Internal Stakeholder Packs</span>
              <div class="col-12 cursor-pointer" *ngIf="isSavedPermission"
                (click)="uploadEvidenceAssessment('uploadInternalStackHolderPacks')">
                <i class="fa fa-upload"></i>
                <span class="text-primary ml-1 fw">Upload - Internal Stakeholder Packs
                  <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
                <input id="uploadInternalStackHolderPacks" #myFileInput1
                  (change)="handleFileInput($event.target.files, FileType.InternalStackholder)" type="file" multiple
                  style="display: none" /><br />
              </div>
              <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                <ng-container *ngFor="let docs of impactAssessmentDocument">
                  <div class="file-div text-center" *ngIf="docs.fileType === FileType.InternalStackholder">
                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isSavedPermission"
                      (click)="openDeleteModel(docs.id)"></span>
                    <span class="cursor-pointer" (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension)">
                      <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                      <i class="fa fa-file-text-o fa-2x"
                        *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                      <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                      <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                      <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                      <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                      <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                      <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                        aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                      <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                      <i class="fa fa-file-powerpoint-o fa-2x"
                        *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{docs.fileName}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">Engagement Plan</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.engagementPlan"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)">
                <option *ngFor="let option of engagementPlan" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span class="control-label d-block mb-2 fw">
                  Engagement Plan Details
                </span>
              </div>
              <!-- <div class="text-area-css overflow-auto"
                                    *ngIf="iaDetailHistory && iaDetailHistory.engagementPlanDetails">
                                    <div class="f-16" *ngIf="engagementPlanInput != ''"
                                        [innerHTML]="sanitizeHtml(engagementPlanInput)">
                                    </div>
                                </div> -->
              <app-ck-editor [(childVariable)]="impactAssessment.engagementPlanDetails" [accessType]="accessType"
                *ngIf="isSADetails5" id="engagementPlanDetails" class="f-16 ck-min-height"
                [data]="impactAssessment.engagementPlanDetails"></app-ck-editor>
              <!-- </div> -->
            </div>
          </div>
          <div class="row ml-2 pt-3">
            <span class="text-primary ml-1 fw" *ngIf="!isSavedPermission">Upload Engagement Plan</span>
            <div class="col-lg-3 cursor-pointer" *ngIf="isSavedPermission"
              (click)="uploadEvidenceAssessment('uploadEviAssessment')">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Engagement Plan
                <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviAssessment" #myFileInput1
                (change)="handleFileInput($event.target.files, FileType.EngagementPlan)" type="file" multiple
                style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of impactAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === FileType.EngagementPlan">
                  <span class="fa fa-trash pull-right delete-docs" *ngIf="isSavedPermission"
                    (click)="openDeleteModel(docs.id)"></span>
                  <span class="cursor-pointer" (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension)">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Policy Response Achieved?</label>
              <select class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.policyResponseAchieved">
                <option *ngFor="let option of policyResponseAchieved" value="{{option}}">{{option}}
                </option>
              </select>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Number of Key Messages</label>
              <input type="number" class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.numberofKeyMessages">
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Key Messages Acheived</label>
              <input type="number" class="form-control form-control-sm"
                [disabled]="(currentUserRole !== 'Compliance Enterprise' && !isSavedPermission)"
                [(ngModel)]="impactAssessment.keyMessagesAcheived">
            </div>
            <div class="col-lg-12 mt-3">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span class="control-label d-block mb-2 fw">
                  Details
                </span>
              </div>
              <!-- <div class="text-area-css overflow-auto"
                                    *ngIf="iaDetailHistory && iaDetailHistory.detail">
                                    <div class="f-16" *ngIf="detailInput != ''" [innerHTML]="sanitizeHtml(detailInput)">
                                    </div>
                                </div> -->
              <!-- <div class="text-area-css overflow-auto disabled-div"
                                    *ngIf="iaDetailHistory && iaDetailHistory.detail"
                                    [innerHTML]="impactAssessment.detail"></div> -->
              <app-ck-editor [(childVariable)]="impactAssessment.detail" id="detail" class="f-16 ck-min-height"
                [accessType]="accessType" *ngIf="isSADetails6" [data]="impactAssessment.detail"></app-ck-editor>
              <!-- </div> -->
            </div>
          </div>
          <!-- Upload Document Work -->

        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="card" *ngIf="!isAuthorised">
  <div class="crad-body p-2">
    <div>You are not authorised to see this impact assessment.</div>
  </div>
</div>